import React, { Component } from "react";
import Footer from "../components/base/Footer";
import Header from "../components/base/Header";
import Table, { TableHeader } from "../components/base/Table";

const headers: TableHeader[] = [
  {
    key: "name",
    title: "NAME",
  },
  {
    key: "rank",
    title: "RANK",
  },
  {
    key: "state",
    title: "STATE",
  },
  {
    key: "co2Save",
    title: "CARBON SAVING",
  },
  {
    key: "contribution",
    title: "CONTRIBUTION TO ECONOMY",
  },
];

export interface RecentActivities {
  name: string;
  rank: number;
  state: string;
  co2Save: string;
  contribution: string;
}

interface State {
  activitiesData: RecentActivities[];
}

const activitiesData = [
  {
    name: "Intel Corporation",
    rank: 1,
    state: "Penang",
    co2Save: "49 ton",
    contribution: "RM 10 Billion",
  },
  {
    name: "Info Tech sdn bhd",
    rank: 2,
    state: "Johor",
    co2Save: "42 ton",
    contribution: "RM 12 Billion",
  },
  {
    name: "Hartalega sdn bhd",
    rank: 3,
    state: "Selangor",
    co2Save: "30 ton",
    contribution: "RM 11 Billion",
  },
  {
    name: "Brand Root sdn bhd",
    rank: 4,
    state: "Kuala Lumpur",
    co2Save: "28 ton",
    contribution: "RM 20 Billion",
  },
  {
    rank: 5,
    name: "Carsome bhd",
    state: "Perak",
    co2Save: "22 ton",
    contribution: "RM 8 Billion",
  },
  {
    name: "Fresh Books sdn bhd",
    rank: 6,
    state: "Pahang",
    co2Save: "21 ton",
    contribution: "RM 5 Billion",
  },
  {
    name: "Worldland sdn bhd",
    rank: 7,
    state: "Sarawak",
    co2Save: "19 ton",
    contribution: "RM 7 Billion",
  },
];

class Ranking extends Component {
  state: State = {
    activitiesData: activitiesData,
  };

  render() {
    return (
      <div className="bg-white">
        <Header page="Home" />
        <div className="relative w-full pb-20">
          <div className="relative max-w-7xl mx-auto pt-4 px-4 lg:pt-4 lg:pb-4 lg:px-4">
            <h2 className="mt-10 text-lg font-semibold text-gray-900">
              Ubi Ranking
            </h2>
            <Table
              dataLimit={6}
              lastCursor={""}
              header={headers}
              data={this.state.activitiesData}
              className={"table-fixed"}
            />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Ranking;
